export default __webpack_public_path__ + "static/media/AdobeStock_43508288.c9897353.jpg";